module.exports = __webpack_public_path__ + "meeting.736eefaec8b26b48ecbe.jpg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/meeting.jpg
// module id = ../../../../../client/assets/img/meeting.jpg
// module chunks = styles